module.exports = __webpack_public_path__ + "assets/Underbite.81114d0fc129341d4c8d9e486ae5e5c0.png";